/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY API
 * PEXIFY API contract (FE ↔ BE).
 *
 * **Status:** M0 initial draft (2026-05-21). This contract is FE-shaped during M0/M1/M2 operational
 * simulation phase per `pol-build-sequence`. Backend implementation begins at M3.
 *
 * **Scope (M0):** IQ-1 Pending Updates Queue endpoints + auth placeholder. Other endpoints added
 * as M0/M1/M2 prototype reveals needs.
 *
 * **Permanent architectural invariant:** JSON only (no GraphQL, no SOAP, no XML). See
 * `planning/nodes/policies/decoupled-api.md` for the full invariant + 5 strategic reasons.
 *
 * OpenAPI spec version: 0.1.0-m0-draft
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Problem,
  StudioBakeoffBatchRead,
  StudioBakeoffComparisonRead,
  StudioBakeoffCreateRequest,
  StudioBakeoffErrorResponse,
  StudioBakeoffItemRead,
  StudioBakeoffPreflightRead,
  StudioBakeoffPreflightRequest,
  StudioBakeoffSubmitRequest,
  StudioCatalogBatchRead,
  StudioCatalogComparisonRead,
  StudioCatalogCreateRequest,
  StudioCatalogErrorResponse,
  StudioCatalogItemRead,
  StudioCatalogPreflightRead,
  StudioCatalogPreflightRequest,
  StudioCatalogRejectRequest,
  StudioCatalogSubmitRequest,
  StudioRecipeClone,
  StudioRecipeCreate,
  StudioRecipeListResult,
  StudioRecipeRead,
  StudioRecipeReplacementRequest
} from '../model';

import { orvalClient } from '../../orval-client';




export type listAdminStudioRecipesResponse200 = {
  data: StudioRecipeListResult
  status: 200
}

export type listAdminStudioRecipesResponse403 = {
  data: Problem
  status: 403
}

export type listAdminStudioRecipesResponseSuccess = (listAdminStudioRecipesResponse200) & {
  headers: Headers;
};
export type listAdminStudioRecipesResponseError = (listAdminStudioRecipesResponse403) & {
  headers: Headers;
};

export type listAdminStudioRecipesResponse = (listAdminStudioRecipesResponseSuccess | listAdminStudioRecipesResponseError)

export const getListAdminStudioRecipesUrl = () => {




  return `/api/v1/admin/studio-generation/recipes`
}

/**
 * @summary List governed immutable Studio recipe versions
 */
export const listAdminStudioRecipes = async ( options?: RequestInit): Promise<listAdminStudioRecipesResponse> => {

  return orvalClient<listAdminStudioRecipesResponse>(getListAdminStudioRecipesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminStudioRecipesQueryKey = () => {
    return [
    `/api/v1/admin/studio-generation/recipes`
    ] as const;
    }


export const getListAdminStudioRecipesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError = Problem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminStudioRecipesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminStudioRecipes>>> = ({ signal }) => listAdminStudioRecipes({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminStudioRecipesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminStudioRecipes>>>
export type ListAdminStudioRecipesQueryError = Problem


export function useListAdminStudioRecipes<TData = Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError = Problem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminStudioRecipes>>,
          TError,
          Awaited<ReturnType<typeof listAdminStudioRecipes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminStudioRecipes<TData = Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminStudioRecipes>>,
          TError,
          Awaited<ReturnType<typeof listAdminStudioRecipes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminStudioRecipes<TData = Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List governed immutable Studio recipe versions
 */

export function useListAdminStudioRecipes<TData = Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStudioRecipes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminStudioRecipesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type createAdminStudioRecipeResponse201 = {
  data: StudioRecipeRead
  status: 201
}

export type createAdminStudioRecipeResponse403 = {
  data: Problem
  status: 403
}

export type createAdminStudioRecipeResponse409 = {
  data: Problem
  status: 409
}

export type createAdminStudioRecipeResponse422 = {
  data: Problem
  status: 422
}

export type createAdminStudioRecipeResponseSuccess = (createAdminStudioRecipeResponse201) & {
  headers: Headers;
};
export type createAdminStudioRecipeResponseError = (createAdminStudioRecipeResponse403 | createAdminStudioRecipeResponse409 | createAdminStudioRecipeResponse422) & {
  headers: Headers;
};

export type createAdminStudioRecipeResponse = (createAdminStudioRecipeResponseSuccess | createAdminStudioRecipeResponseError)

export const getCreateAdminStudioRecipeUrl = () => {




  return `/api/v1/admin/studio-generation/recipes`
}

/**
 * @summary Create one immutable draft Studio recipe
 */
export const createAdminStudioRecipe = async (studioRecipeCreate: StudioRecipeCreate, options?: RequestInit): Promise<createAdminStudioRecipeResponse> => {

  return orvalClient<createAdminStudioRecipeResponse>(getCreateAdminStudioRecipeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(studioRecipeCreate)
  }
);}




export const getCreateAdminStudioRecipeMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminStudioRecipe>>, TError,{data: StudioRecipeCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminStudioRecipe>>, TError,{data: StudioRecipeCreate}, TContext> => {

const mutationKey = ['createAdminStudioRecipe'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminStudioRecipe>>, {data: StudioRecipeCreate}> = (props) => {
          const {data} = props ?? {};

          return  createAdminStudioRecipe(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminStudioRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminStudioRecipe>>>
    export type CreateAdminStudioRecipeMutationBody = StudioRecipeCreate
    export type CreateAdminStudioRecipeMutationError = Problem

    /**
 * @summary Create one immutable draft Studio recipe
 */
export const useCreateAdminStudioRecipe = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminStudioRecipe>>, TError,{data: StudioRecipeCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminStudioRecipe>>,
        TError,
        {data: StudioRecipeCreate},
        TContext
      > => {
      return useMutation(getCreateAdminStudioRecipeMutationOptions(options), queryClient);
    }
    export type cloneAdminStudioRecipeResponse201 = {
  data: StudioRecipeRead
  status: 201
}

export type cloneAdminStudioRecipeResponse403 = {
  data: Problem
  status: 403
}

export type cloneAdminStudioRecipeResponse404 = {
  data: Problem
  status: 404
}

export type cloneAdminStudioRecipeResponse409 = {
  data: Problem
  status: 409
}

export type cloneAdminStudioRecipeResponse422 = {
  data: Problem
  status: 422
}

export type cloneAdminStudioRecipeResponseSuccess = (cloneAdminStudioRecipeResponse201) & {
  headers: Headers;
};
export type cloneAdminStudioRecipeResponseError = (cloneAdminStudioRecipeResponse403 | cloneAdminStudioRecipeResponse404 | cloneAdminStudioRecipeResponse409 | cloneAdminStudioRecipeResponse422) & {
  headers: Headers;
};

export type cloneAdminStudioRecipeResponse = (cloneAdminStudioRecipeResponseSuccess | cloneAdminStudioRecipeResponseError)

export const getCloneAdminStudioRecipeUrl = (recipeId: string,) => {




  return `/api/v1/admin/studio-generation/recipes/${recipeId}/clone`
}

/**
 * @summary Clone an immutable recipe into its next draft version
 */
export const cloneAdminStudioRecipe = async (recipeId: string,
    studioRecipeClone: StudioRecipeClone, options?: RequestInit): Promise<cloneAdminStudioRecipeResponse> => {

  return orvalClient<cloneAdminStudioRecipeResponse>(getCloneAdminStudioRecipeUrl(recipeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(studioRecipeClone)
  }
);}




export const getCloneAdminStudioRecipeMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneAdminStudioRecipe>>, TError,{recipeId: string;data: StudioRecipeClone}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cloneAdminStudioRecipe>>, TError,{recipeId: string;data: StudioRecipeClone}, TContext> => {

const mutationKey = ['cloneAdminStudioRecipe'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneAdminStudioRecipe>>, {recipeId: string;data: StudioRecipeClone}> = (props) => {
          const {recipeId,data} = props ?? {};

          return  cloneAdminStudioRecipe(recipeId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneAdminStudioRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof cloneAdminStudioRecipe>>>
    export type CloneAdminStudioRecipeMutationBody = StudioRecipeClone
    export type CloneAdminStudioRecipeMutationError = Problem

    /**
 * @summary Clone an immutable recipe into its next draft version
 */
export const useCloneAdminStudioRecipe = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneAdminStudioRecipe>>, TError,{recipeId: string;data: StudioRecipeClone}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneAdminStudioRecipe>>,
        TError,
        {recipeId: string;data: StudioRecipeClone},
        TContext
      > => {
      return useMutation(getCloneAdminStudioRecipeMutationOptions(options), queryClient);
    }
    export type pilotAdminStudioRecipeResponse200 = {
  data: StudioRecipeRead
  status: 200
}

export type pilotAdminStudioRecipeResponse403 = {
  data: Problem
  status: 403
}

export type pilotAdminStudioRecipeResponse404 = {
  data: Problem
  status: 404
}

export type pilotAdminStudioRecipeResponse422 = {
  data: Problem
  status: 422
}

export type pilotAdminStudioRecipeResponseSuccess = (pilotAdminStudioRecipeResponse200) & {
  headers: Headers;
};
export type pilotAdminStudioRecipeResponseError = (pilotAdminStudioRecipeResponse403 | pilotAdminStudioRecipeResponse404 | pilotAdminStudioRecipeResponse422) & {
  headers: Headers;
};

export type pilotAdminStudioRecipeResponse = (pilotAdminStudioRecipeResponseSuccess | pilotAdminStudioRecipeResponseError)

export const getPilotAdminStudioRecipeUrl = (recipeId: string,) => {




  return `/api/v1/admin/studio-generation/recipes/${recipeId}/pilot`
}

/**
 * @summary Promote one draft recipe to the catalog-eligible pilot state without provider I/O
 */
export const pilotAdminStudioRecipe = async (recipeId: string, options?: RequestInit): Promise<pilotAdminStudioRecipeResponse> => {

  return orvalClient<pilotAdminStudioRecipeResponse>(getPilotAdminStudioRecipeUrl(recipeId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPilotAdminStudioRecipeMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pilotAdminStudioRecipe>>, TError,{recipeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pilotAdminStudioRecipe>>, TError,{recipeId: string}, TContext> => {

const mutationKey = ['pilotAdminStudioRecipe'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pilotAdminStudioRecipe>>, {recipeId: string}> = (props) => {
          const {recipeId} = props ?? {};

          return  pilotAdminStudioRecipe(recipeId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PilotAdminStudioRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof pilotAdminStudioRecipe>>>

    export type PilotAdminStudioRecipeMutationError = Problem

    /**
 * @summary Promote one draft recipe to the catalog-eligible pilot state without provider I/O
 */
export const usePilotAdminStudioRecipe = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pilotAdminStudioRecipe>>, TError,{recipeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pilotAdminStudioRecipe>>,
        TError,
        {recipeId: string},
        TContext
      > => {
      return useMutation(getPilotAdminStudioRecipeMutationOptions(options), queryClient);
    }
    export type replaceIncompatibleAdminStudioRecipeResponse200 = {
  data: StudioRecipeRead
  status: 200
}

export type replaceIncompatibleAdminStudioRecipeResponse403 = {
  data: Problem
  status: 403
}

export type replaceIncompatibleAdminStudioRecipeResponse404 = {
  data: Problem
  status: 404
}

export type replaceIncompatibleAdminStudioRecipeResponse409 = {
  data: Problem
  status: 409
}

export type replaceIncompatibleAdminStudioRecipeResponse422 = {
  data: Problem
  status: 422
}

export type replaceIncompatibleAdminStudioRecipeResponseSuccess = (replaceIncompatibleAdminStudioRecipeResponse200) & {
  headers: Headers;
};
export type replaceIncompatibleAdminStudioRecipeResponseError = (replaceIncompatibleAdminStudioRecipeResponse403 | replaceIncompatibleAdminStudioRecipeResponse404 | replaceIncompatibleAdminStudioRecipeResponse409 | replaceIncompatibleAdminStudioRecipeResponse422) & {
  headers: Headers;
};

export type replaceIncompatibleAdminStudioRecipeResponse = (replaceIncompatibleAdminStudioRecipeResponseSuccess | replaceIncompatibleAdminStudioRecipeResponseError)

export const getReplaceIncompatibleAdminStudioRecipeUrl = (recipeId: string,) => {




  return `/api/v1/admin/studio-generation/recipes/${recipeId}/replace-incompatible`
}

/**
 * @summary Atomically replace one incompatible immutable recipe without provider I/O
 */
export const replaceIncompatibleAdminStudioRecipe = async (recipeId: string,
    studioRecipeReplacementRequest: StudioRecipeReplacementRequest, options?: RequestInit): Promise<replaceIncompatibleAdminStudioRecipeResponse> => {

  return orvalClient<replaceIncompatibleAdminStudioRecipeResponse>(getReplaceIncompatibleAdminStudioRecipeUrl(recipeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(studioRecipeReplacementRequest)
  }
);}




export const getReplaceIncompatibleAdminStudioRecipeMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceIncompatibleAdminStudioRecipe>>, TError,{recipeId: string;data: StudioRecipeReplacementRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof replaceIncompatibleAdminStudioRecipe>>, TError,{recipeId: string;data: StudioRecipeReplacementRequest}, TContext> => {

const mutationKey = ['replaceIncompatibleAdminStudioRecipe'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceIncompatibleAdminStudioRecipe>>, {recipeId: string;data: StudioRecipeReplacementRequest}> = (props) => {
          const {recipeId,data} = props ?? {};

          return  replaceIncompatibleAdminStudioRecipe(recipeId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceIncompatibleAdminStudioRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof replaceIncompatibleAdminStudioRecipe>>>
    export type ReplaceIncompatibleAdminStudioRecipeMutationBody = StudioRecipeReplacementRequest
    export type ReplaceIncompatibleAdminStudioRecipeMutationError = Problem

    /**
 * @summary Atomically replace one incompatible immutable recipe without provider I/O
 */
export const useReplaceIncompatibleAdminStudioRecipe = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceIncompatibleAdminStudioRecipe>>, TError,{recipeId: string;data: StudioRecipeReplacementRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceIncompatibleAdminStudioRecipe>>,
        TError,
        {recipeId: string;data: StudioRecipeReplacementRequest},
        TContext
      > => {
      return useMutation(getReplaceIncompatibleAdminStudioRecipeMutationOptions(options), queryClient);
    }
    export type preflightAdminStudioBakeoffResponse200 = {
  data: StudioBakeoffPreflightRead
  status: 200
}

export type preflightAdminStudioBakeoffResponse403 = {
  data: StudioBakeoffErrorResponse
  status: 403
}

export type preflightAdminStudioBakeoffResponse404 = {
  data: StudioBakeoffErrorResponse
  status: 404
}

export type preflightAdminStudioBakeoffResponse422 = {
  data: StudioBakeoffErrorResponse
  status: 422
}

export type preflightAdminStudioBakeoffResponseSuccess = (preflightAdminStudioBakeoffResponse200) & {
  headers: Headers;
};
export type preflightAdminStudioBakeoffResponseError = (preflightAdminStudioBakeoffResponse403 | preflightAdminStudioBakeoffResponse404 | preflightAdminStudioBakeoffResponse422) & {
  headers: Headers;
};

export type preflightAdminStudioBakeoffResponse = (preflightAdminStudioBakeoffResponseSuccess | preflightAdminStudioBakeoffResponseError)

export const getPreflightAdminStudioBakeoffUrl = () => {




  return `/api/v1/admin/studio-generation/preflight`
}

/**
 * @summary Resolve one product and the exact three draft recipes without provider I/O
 */
export const preflightAdminStudioBakeoff = async (studioBakeoffPreflightRequest: StudioBakeoffPreflightRequest, options?: RequestInit): Promise<preflightAdminStudioBakeoffResponse> => {

  return orvalClient<preflightAdminStudioBakeoffResponse>(getPreflightAdminStudioBakeoffUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(studioBakeoffPreflightRequest)
  }
);}




export const getPreflightAdminStudioBakeoffMutationOptions = <TError = StudioBakeoffErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof preflightAdminStudioBakeoff>>, TError,{data: StudioBakeoffPreflightRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof preflightAdminStudioBakeoff>>, TError,{data: StudioBakeoffPreflightRequest}, TContext> => {

const mutationKey = ['preflightAdminStudioBakeoff'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof preflightAdminStudioBakeoff>>, {data: StudioBakeoffPreflightRequest}> = (props) => {
          const {data} = props ?? {};

          return  preflightAdminStudioBakeoff(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreflightAdminStudioBakeoffMutationResult = NonNullable<Awaited<ReturnType<typeof preflightAdminStudioBakeoff>>>
    export type PreflightAdminStudioBakeoffMutationBody = StudioBakeoffPreflightRequest
    export type PreflightAdminStudioBakeoffMutationError = StudioBakeoffErrorResponse

    /**
 * @summary Resolve one product and the exact three draft recipes without provider I/O
 */
export const usePreflightAdminStudioBakeoff = <TError = StudioBakeoffErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof preflightAdminStudioBakeoff>>, TError,{data: StudioBakeoffPreflightRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof preflightAdminStudioBakeoff>>,
        TError,
        {data: StudioBakeoffPreflightRequest},
        TContext
      > => {
      return useMutation(getPreflightAdminStudioBakeoffMutationOptions(options), queryClient);
    }
    export type createAdminStudioBakeoffResponse201 = {
  data: StudioBakeoffBatchRead
  status: 201
}

export type createAdminStudioBakeoffResponse403 = {
  data: StudioBakeoffErrorResponse
  status: 403
}

export type createAdminStudioBakeoffResponse409 = {
  data: StudioBakeoffErrorResponse
  status: 409
}

export type createAdminStudioBakeoffResponse422 = {
  data: StudioBakeoffErrorResponse
  status: 422
}

export type createAdminStudioBakeoffResponseSuccess = (createAdminStudioBakeoffResponse201) & {
  headers: Headers;
};
export type createAdminStudioBakeoffResponseError = (createAdminStudioBakeoffResponse403 | createAdminStudioBakeoffResponse409 | createAdminStudioBakeoffResponse422) & {
  headers: Headers;
};

export type createAdminStudioBakeoffResponse = (createAdminStudioBakeoffResponseSuccess | createAdminStudioBakeoffResponseError)

export const getCreateAdminStudioBakeoffUrl = () => {




  return `/api/v1/admin/studio-generation/batches`
}

/**
 * @summary Atomically create one three-item provider bake-off
 */
export const createAdminStudioBakeoff = async (studioBakeoffCreateRequest: StudioBakeoffCreateRequest, options?: RequestInit): Promise<createAdminStudioBakeoffResponse> => {

  return orvalClient<createAdminStudioBakeoffResponse>(getCreateAdminStudioBakeoffUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(studioBakeoffCreateRequest)
  }
);}




export const getCreateAdminStudioBakeoffMutationOptions = <TError = StudioBakeoffErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminStudioBakeoff>>, TError,{data: StudioBakeoffCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminStudioBakeoff>>, TError,{data: StudioBakeoffCreateRequest}, TContext> => {

const mutationKey = ['createAdminStudioBakeoff'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminStudioBakeoff>>, {data: StudioBakeoffCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAdminStudioBakeoff(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminStudioBakeoffMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminStudioBakeoff>>>
    export type CreateAdminStudioBakeoffMutationBody = StudioBakeoffCreateRequest
    export type CreateAdminStudioBakeoffMutationError = StudioBakeoffErrorResponse

    /**
 * @summary Atomically create one three-item provider bake-off
 */
export const useCreateAdminStudioBakeoff = <TError = StudioBakeoffErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminStudioBakeoff>>, TError,{data: StudioBakeoffCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminStudioBakeoff>>,
        TError,
        {data: StudioBakeoffCreateRequest},
        TContext
      > => {
      return useMutation(getCreateAdminStudioBakeoffMutationOptions(options), queryClient);
    }
    export type getAdminStudioBakeoffResponse200 = {
  data: StudioBakeoffBatchRead
  status: 200
}

export type getAdminStudioBakeoffResponse403 = {
  data: StudioBakeoffErrorResponse
  status: 403
}

export type getAdminStudioBakeoffResponse404 = {
  data: StudioBakeoffErrorResponse
  status: 404
}

export type getAdminStudioBakeoffResponseSuccess = (getAdminStudioBakeoffResponse200) & {
  headers: Headers;
};
export type getAdminStudioBakeoffResponseError = (getAdminStudioBakeoffResponse403 | getAdminStudioBakeoffResponse404) & {
  headers: Headers;
};

export type getAdminStudioBakeoffResponse = (getAdminStudioBakeoffResponseSuccess | getAdminStudioBakeoffResponseError)

export const getGetAdminStudioBakeoffUrl = (batchId: string,) => {




  return `/api/v1/admin/studio-generation/batches/${batchId}`
}

/**
 * @summary Read one safe provider bake-off projection
 */
export const getAdminStudioBakeoff = async (batchId: string, options?: RequestInit): Promise<getAdminStudioBakeoffResponse> => {

  return orvalClient<getAdminStudioBakeoffResponse>(getGetAdminStudioBakeoffUrl(batchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminStudioBakeoffQueryKey = (batchId: string,) => {
    return [
    `/api/v1/admin/studio-generation/batches/${batchId}`
    ] as const;
    }


export const getGetAdminStudioBakeoffQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError = StudioBakeoffErrorResponse>(batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStudioBakeoffQueryKey(batchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStudioBakeoff>>> = ({ signal }) => getAdminStudioBakeoff(batchId, { signal });





   return  { queryKey, queryFn, enabled: batchId !== null && batchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminStudioBakeoffQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStudioBakeoff>>>
export type GetAdminStudioBakeoffQueryError = StudioBakeoffErrorResponse


export function useGetAdminStudioBakeoff<TData = Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError = StudioBakeoffErrorResponse>(
 batchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminStudioBakeoff>>,
          TError,
          Awaited<ReturnType<typeof getAdminStudioBakeoff>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStudioBakeoff<TData = Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError = StudioBakeoffErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminStudioBakeoff>>,
          TError,
          Awaited<ReturnType<typeof getAdminStudioBakeoff>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStudioBakeoff<TData = Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError = StudioBakeoffErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one safe provider bake-off projection
 */

export function useGetAdminStudioBakeoff<TData = Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError = StudioBakeoffErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioBakeoff>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminStudioBakeoffQueryOptions(batchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type submitAdminStudioBakeoffItemResponse202 = {
  data: StudioBakeoffItemRead
  status: 202
}

export type submitAdminStudioBakeoffItemResponse403 = {
  data: StudioBakeoffErrorResponse
  status: 403
}

export type submitAdminStudioBakeoffItemResponse404 = {
  data: StudioBakeoffErrorResponse
  status: 404
}

export type submitAdminStudioBakeoffItemResponse409 = {
  data: StudioBakeoffErrorResponse
  status: 409
}

export type submitAdminStudioBakeoffItemResponseSuccess = (submitAdminStudioBakeoffItemResponse202) & {
  headers: Headers;
};
export type submitAdminStudioBakeoffItemResponseError = (submitAdminStudioBakeoffItemResponse403 | submitAdminStudioBakeoffItemResponse404 | submitAdminStudioBakeoffItemResponse409) & {
  headers: Headers;
};

export type submitAdminStudioBakeoffItemResponse = (submitAdminStudioBakeoffItemResponseSuccess | submitAdminStudioBakeoffItemResponseError)

export const getSubmitAdminStudioBakeoffItemUrl = (itemId: string,) => {




  return `/api/v1/admin/studio-generation/items/${itemId}/submit`
}

/**
 * @summary Durably enqueue one item without provider I/O in the request
 */
export const submitAdminStudioBakeoffItem = async (itemId: string,
    studioBakeoffSubmitRequest: StudioBakeoffSubmitRequest, options?: RequestInit): Promise<submitAdminStudioBakeoffItemResponse> => {

  return orvalClient<submitAdminStudioBakeoffItemResponse>(getSubmitAdminStudioBakeoffItemUrl(itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(studioBakeoffSubmitRequest)
  }
);}




export const getSubmitAdminStudioBakeoffItemMutationOptions = <TError = StudioBakeoffErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAdminStudioBakeoffItem>>, TError,{itemId: string;data: StudioBakeoffSubmitRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitAdminStudioBakeoffItem>>, TError,{itemId: string;data: StudioBakeoffSubmitRequest}, TContext> => {

const mutationKey = ['submitAdminStudioBakeoffItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAdminStudioBakeoffItem>>, {itemId: string;data: StudioBakeoffSubmitRequest}> = (props) => {
          const {itemId,data} = props ?? {};

          return  submitAdminStudioBakeoffItem(itemId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitAdminStudioBakeoffItemMutationResult = NonNullable<Awaited<ReturnType<typeof submitAdminStudioBakeoffItem>>>
    export type SubmitAdminStudioBakeoffItemMutationBody = StudioBakeoffSubmitRequest
    export type SubmitAdminStudioBakeoffItemMutationError = StudioBakeoffErrorResponse

    /**
 * @summary Durably enqueue one item without provider I/O in the request
 */
export const useSubmitAdminStudioBakeoffItem = <TError = StudioBakeoffErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAdminStudioBakeoffItem>>, TError,{itemId: string;data: StudioBakeoffSubmitRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitAdminStudioBakeoffItem>>,
        TError,
        {itemId: string;data: StudioBakeoffSubmitRequest},
        TContext
      > => {
      return useMutation(getSubmitAdminStudioBakeoffItemMutationOptions(options), queryClient);
    }
    export type compareAdminStudioBakeoffResponse200 = {
  data: StudioBakeoffComparisonRead
  status: 200
}

export type compareAdminStudioBakeoffResponse403 = {
  data: StudioBakeoffErrorResponse
  status: 403
}

export type compareAdminStudioBakeoffResponse404 = {
  data: StudioBakeoffErrorResponse
  status: 404
}

export type compareAdminStudioBakeoffResponseSuccess = (compareAdminStudioBakeoffResponse200) & {
  headers: Headers;
};
export type compareAdminStudioBakeoffResponseError = (compareAdminStudioBakeoffResponse403 | compareAdminStudioBakeoffResponse404) & {
  headers: Headers;
};

export type compareAdminStudioBakeoffResponse = (compareAdminStudioBakeoffResponseSuccess | compareAdminStudioBakeoffResponseError)

export const getCompareAdminStudioBakeoffUrl = (batchId: string,) => {




  return `/api/v1/admin/studio-generation/batches/${batchId}/comparison`
}

/**
 * @summary Read source plus three Drive-backed results in fixed operation order
 */
export const compareAdminStudioBakeoff = async (batchId: string, options?: RequestInit): Promise<compareAdminStudioBakeoffResponse> => {

  return orvalClient<compareAdminStudioBakeoffResponse>(getCompareAdminStudioBakeoffUrl(batchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompareAdminStudioBakeoffQueryKey = (batchId: string,) => {
    return [
    `/api/v1/admin/studio-generation/batches/${batchId}/comparison`
    ] as const;
    }


export const getCompareAdminStudioBakeoffQueryOptions = <TData = Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError = StudioBakeoffErrorResponse>(batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompareAdminStudioBakeoffQueryKey(batchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof compareAdminStudioBakeoff>>> = ({ signal }) => compareAdminStudioBakeoff(batchId, { signal });





   return  { queryKey, queryFn, enabled: batchId !== null && batchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompareAdminStudioBakeoffQueryResult = NonNullable<Awaited<ReturnType<typeof compareAdminStudioBakeoff>>>
export type CompareAdminStudioBakeoffQueryError = StudioBakeoffErrorResponse


export function useCompareAdminStudioBakeoff<TData = Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError = StudioBakeoffErrorResponse>(
 batchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareAdminStudioBakeoff>>,
          TError,
          Awaited<ReturnType<typeof compareAdminStudioBakeoff>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompareAdminStudioBakeoff<TData = Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError = StudioBakeoffErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareAdminStudioBakeoff>>,
          TError,
          Awaited<ReturnType<typeof compareAdminStudioBakeoff>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompareAdminStudioBakeoff<TData = Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError = StudioBakeoffErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read source plus three Drive-backed results in fixed operation order
 */

export function useCompareAdminStudioBakeoff<TData = Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError = StudioBakeoffErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioBakeoff>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompareAdminStudioBakeoffQueryOptions(batchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type preflightAdminStudioCatalogGenerationResponse200 = {
  data: StudioCatalogPreflightRead
  status: 200
}

export type preflightAdminStudioCatalogGenerationResponse403 = {
  data: StudioCatalogErrorResponse
  status: 403
}

export type preflightAdminStudioCatalogGenerationResponse404 = {
  data: StudioCatalogErrorResponse
  status: 404
}

export type preflightAdminStudioCatalogGenerationResponseSuccess = (preflightAdminStudioCatalogGenerationResponse200) & {
  headers: Headers;
};
export type preflightAdminStudioCatalogGenerationResponseError = (preflightAdminStudioCatalogGenerationResponse403 | preflightAdminStudioCatalogGenerationResponse404) & {
  headers: Headers;
};

export type preflightAdminStudioCatalogGenerationResponse = (preflightAdminStudioCatalogGenerationResponseSuccess | preflightAdminStudioCatalogGenerationResponseError)

export const getPreflightAdminStudioCatalogGenerationUrl = () => {




  return `/api/v1/admin/studio-generation/catalog/preflight`
}

/**
 * @summary Validate one exact product-media target without provider I/O
 */
export const preflightAdminStudioCatalogGeneration = async (studioCatalogPreflightRequest: StudioCatalogPreflightRequest, options?: RequestInit): Promise<preflightAdminStudioCatalogGenerationResponse> => {

  return orvalClient<preflightAdminStudioCatalogGenerationResponse>(getPreflightAdminStudioCatalogGenerationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(studioCatalogPreflightRequest)
  }
);}




export const getPreflightAdminStudioCatalogGenerationMutationOptions = <TError = StudioCatalogErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof preflightAdminStudioCatalogGeneration>>, TError,{data: StudioCatalogPreflightRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof preflightAdminStudioCatalogGeneration>>, TError,{data: StudioCatalogPreflightRequest}, TContext> => {

const mutationKey = ['preflightAdminStudioCatalogGeneration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof preflightAdminStudioCatalogGeneration>>, {data: StudioCatalogPreflightRequest}> = (props) => {
          const {data} = props ?? {};

          return  preflightAdminStudioCatalogGeneration(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreflightAdminStudioCatalogGenerationMutationResult = NonNullable<Awaited<ReturnType<typeof preflightAdminStudioCatalogGeneration>>>
    export type PreflightAdminStudioCatalogGenerationMutationBody = StudioCatalogPreflightRequest
    export type PreflightAdminStudioCatalogGenerationMutationError = StudioCatalogErrorResponse

    /**
 * @summary Validate one exact product-media target without provider I/O
 */
export const usePreflightAdminStudioCatalogGeneration = <TError = StudioCatalogErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof preflightAdminStudioCatalogGeneration>>, TError,{data: StudioCatalogPreflightRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof preflightAdminStudioCatalogGeneration>>,
        TError,
        {data: StudioCatalogPreflightRequest},
        TContext
      > => {
      return useMutation(getPreflightAdminStudioCatalogGenerationMutationOptions(options), queryClient);
    }
    export type createAdminStudioCatalogGenerationResponse201 = {
  data: StudioCatalogBatchRead
  status: 201
}

export type createAdminStudioCatalogGenerationResponse409 = {
  data: StudioCatalogErrorResponse
  status: 409
}

export type createAdminStudioCatalogGenerationResponse422 = {
  data: StudioCatalogErrorResponse
  status: 422
}

export type createAdminStudioCatalogGenerationResponseSuccess = (createAdminStudioCatalogGenerationResponse201) & {
  headers: Headers;
};
export type createAdminStudioCatalogGenerationResponseError = (createAdminStudioCatalogGenerationResponse409 | createAdminStudioCatalogGenerationResponse422) & {
  headers: Headers;
};

export type createAdminStudioCatalogGenerationResponse = (createAdminStudioCatalogGenerationResponseSuccess | createAdminStudioCatalogGenerationResponseError)

export const getCreateAdminStudioCatalogGenerationUrl = () => {




  return `/api/v1/admin/studio-generation/catalog/batches`
}

/**
 * @summary Create one no-spend attended catalog pilot
 */
export const createAdminStudioCatalogGeneration = async (studioCatalogCreateRequest: StudioCatalogCreateRequest, options?: RequestInit): Promise<createAdminStudioCatalogGenerationResponse> => {

  return orvalClient<createAdminStudioCatalogGenerationResponse>(getCreateAdminStudioCatalogGenerationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(studioCatalogCreateRequest)
  }
);}




export const getCreateAdminStudioCatalogGenerationMutationOptions = <TError = StudioCatalogErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminStudioCatalogGeneration>>, TError,{data: StudioCatalogCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminStudioCatalogGeneration>>, TError,{data: StudioCatalogCreateRequest}, TContext> => {

const mutationKey = ['createAdminStudioCatalogGeneration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminStudioCatalogGeneration>>, {data: StudioCatalogCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAdminStudioCatalogGeneration(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminStudioCatalogGenerationMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminStudioCatalogGeneration>>>
    export type CreateAdminStudioCatalogGenerationMutationBody = StudioCatalogCreateRequest
    export type CreateAdminStudioCatalogGenerationMutationError = StudioCatalogErrorResponse

    /**
 * @summary Create one no-spend attended catalog pilot
 */
export const useCreateAdminStudioCatalogGeneration = <TError = StudioCatalogErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminStudioCatalogGeneration>>, TError,{data: StudioCatalogCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminStudioCatalogGeneration>>,
        TError,
        {data: StudioCatalogCreateRequest},
        TContext
      > => {
      return useMutation(getCreateAdminStudioCatalogGenerationMutationOptions(options), queryClient);
    }
    export type getAdminStudioCatalogGenerationResponse200 = {
  data: StudioCatalogBatchRead
  status: 200
}

export type getAdminStudioCatalogGenerationResponse404 = {
  data: StudioCatalogErrorResponse
  status: 404
}

export type getAdminStudioCatalogGenerationResponseSuccess = (getAdminStudioCatalogGenerationResponse200) & {
  headers: Headers;
};
export type getAdminStudioCatalogGenerationResponseError = (getAdminStudioCatalogGenerationResponse404) & {
  headers: Headers;
};

export type getAdminStudioCatalogGenerationResponse = (getAdminStudioCatalogGenerationResponseSuccess | getAdminStudioCatalogGenerationResponseError)

export const getGetAdminStudioCatalogGenerationUrl = (batchId: string,) => {




  return `/api/v1/admin/studio-generation/catalog/batches/${batchId}`
}

/**
 * @summary Read one attended catalog pilot
 */
export const getAdminStudioCatalogGeneration = async (batchId: string, options?: RequestInit): Promise<getAdminStudioCatalogGenerationResponse> => {

  return orvalClient<getAdminStudioCatalogGenerationResponse>(getGetAdminStudioCatalogGenerationUrl(batchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminStudioCatalogGenerationQueryKey = (batchId: string,) => {
    return [
    `/api/v1/admin/studio-generation/catalog/batches/${batchId}`
    ] as const;
    }


export const getGetAdminStudioCatalogGenerationQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError = StudioCatalogErrorResponse>(batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStudioCatalogGenerationQueryKey(batchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>> = ({ signal }) => getAdminStudioCatalogGeneration(batchId, { signal });





   return  { queryKey, queryFn, enabled: batchId !== null && batchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminStudioCatalogGenerationQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>>
export type GetAdminStudioCatalogGenerationQueryError = StudioCatalogErrorResponse


export function useGetAdminStudioCatalogGeneration<TData = Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError = StudioCatalogErrorResponse>(
 batchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>,
          TError,
          Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStudioCatalogGeneration<TData = Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError = StudioCatalogErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>,
          TError,
          Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStudioCatalogGeneration<TData = Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError = StudioCatalogErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one attended catalog pilot
 */

export function useGetAdminStudioCatalogGeneration<TData = Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError = StudioCatalogErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStudioCatalogGeneration>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminStudioCatalogGenerationQueryOptions(batchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type submitAdminStudioCatalogGenerationItemResponse202 = {
  data: StudioCatalogItemRead
  status: 202
}

export type submitAdminStudioCatalogGenerationItemResponse403 = {
  data: StudioCatalogErrorResponse
  status: 403
}

export type submitAdminStudioCatalogGenerationItemResponse409 = {
  data: StudioCatalogErrorResponse
  status: 409
}

export type submitAdminStudioCatalogGenerationItemResponseSuccess = (submitAdminStudioCatalogGenerationItemResponse202) & {
  headers: Headers;
};
export type submitAdminStudioCatalogGenerationItemResponseError = (submitAdminStudioCatalogGenerationItemResponse403 | submitAdminStudioCatalogGenerationItemResponse409) & {
  headers: Headers;
};

export type submitAdminStudioCatalogGenerationItemResponse = (submitAdminStudioCatalogGenerationItemResponseSuccess | submitAdminStudioCatalogGenerationItemResponseError)

export const getSubmitAdminStudioCatalogGenerationItemUrl = (itemId: string,) => {




  return `/api/v1/admin/studio-generation/catalog/items/${itemId}/submit`
}

/**
 * @summary Explicitly confirm and enqueue the one estimated 75-credit call
 */
export const submitAdminStudioCatalogGenerationItem = async (itemId: string,
    studioCatalogSubmitRequest: StudioCatalogSubmitRequest, options?: RequestInit): Promise<submitAdminStudioCatalogGenerationItemResponse> => {

  return orvalClient<submitAdminStudioCatalogGenerationItemResponse>(getSubmitAdminStudioCatalogGenerationItemUrl(itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(studioCatalogSubmitRequest)
  }
);}




export const getSubmitAdminStudioCatalogGenerationItemMutationOptions = <TError = StudioCatalogErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAdminStudioCatalogGenerationItem>>, TError,{itemId: string;data: StudioCatalogSubmitRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitAdminStudioCatalogGenerationItem>>, TError,{itemId: string;data: StudioCatalogSubmitRequest}, TContext> => {

const mutationKey = ['submitAdminStudioCatalogGenerationItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAdminStudioCatalogGenerationItem>>, {itemId: string;data: StudioCatalogSubmitRequest}> = (props) => {
          const {itemId,data} = props ?? {};

          return  submitAdminStudioCatalogGenerationItem(itemId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitAdminStudioCatalogGenerationItemMutationResult = NonNullable<Awaited<ReturnType<typeof submitAdminStudioCatalogGenerationItem>>>
    export type SubmitAdminStudioCatalogGenerationItemMutationBody = StudioCatalogSubmitRequest
    export type SubmitAdminStudioCatalogGenerationItemMutationError = StudioCatalogErrorResponse

    /**
 * @summary Explicitly confirm and enqueue the one estimated 75-credit call
 */
export const useSubmitAdminStudioCatalogGenerationItem = <TError = StudioCatalogErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAdminStudioCatalogGenerationItem>>, TError,{itemId: string;data: StudioCatalogSubmitRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitAdminStudioCatalogGenerationItem>>,
        TError,
        {itemId: string;data: StudioCatalogSubmitRequest},
        TContext
      > => {
      return useMutation(getSubmitAdminStudioCatalogGenerationItemMutationOptions(options), queryClient);
    }
    export type compareAdminStudioCatalogGenerationResponse200 = {
  data: StudioCatalogComparisonRead
  status: 200
}

export type compareAdminStudioCatalogGenerationResponse409 = {
  data: StudioCatalogErrorResponse
  status: 409
}

export type compareAdminStudioCatalogGenerationResponseSuccess = (compareAdminStudioCatalogGenerationResponse200) & {
  headers: Headers;
};
export type compareAdminStudioCatalogGenerationResponseError = (compareAdminStudioCatalogGenerationResponse409) & {
  headers: Headers;
};

export type compareAdminStudioCatalogGenerationResponse = (compareAdminStudioCatalogGenerationResponseSuccess | compareAdminStudioCatalogGenerationResponseError)

export const getCompareAdminStudioCatalogGenerationUrl = (batchId: string,) => {




  return `/api/v1/admin/studio-generation/catalog/batches/${batchId}/comparison`
}

/**
 * @summary Read source and generated result side by side
 */
export const compareAdminStudioCatalogGeneration = async (batchId: string, options?: RequestInit): Promise<compareAdminStudioCatalogGenerationResponse> => {

  return orvalClient<compareAdminStudioCatalogGenerationResponse>(getCompareAdminStudioCatalogGenerationUrl(batchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompareAdminStudioCatalogGenerationQueryKey = (batchId: string,) => {
    return [
    `/api/v1/admin/studio-generation/catalog/batches/${batchId}/comparison`
    ] as const;
    }


export const getCompareAdminStudioCatalogGenerationQueryOptions = <TData = Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError = StudioCatalogErrorResponse>(batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompareAdminStudioCatalogGenerationQueryKey(batchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>> = ({ signal }) => compareAdminStudioCatalogGeneration(batchId, { signal });





   return  { queryKey, queryFn, enabled: batchId !== null && batchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompareAdminStudioCatalogGenerationQueryResult = NonNullable<Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>>
export type CompareAdminStudioCatalogGenerationQueryError = StudioCatalogErrorResponse


export function useCompareAdminStudioCatalogGeneration<TData = Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError = StudioCatalogErrorResponse>(
 batchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>,
          TError,
          Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompareAdminStudioCatalogGeneration<TData = Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError = StudioCatalogErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>,
          TError,
          Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompareAdminStudioCatalogGeneration<TData = Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError = StudioCatalogErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read source and generated result side by side
 */

export function useCompareAdminStudioCatalogGeneration<TData = Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError = StudioCatalogErrorResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAdminStudioCatalogGeneration>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompareAdminStudioCatalogGenerationQueryOptions(batchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type approveAdminStudioCatalogGenerationItemResponse200 = {
  data: StudioCatalogBatchRead
  status: 200
}

export type approveAdminStudioCatalogGenerationItemResponse409 = {
  data: StudioCatalogErrorResponse
  status: 409
}

export type approveAdminStudioCatalogGenerationItemResponseSuccess = (approveAdminStudioCatalogGenerationItemResponse200) & {
  headers: Headers;
};
export type approveAdminStudioCatalogGenerationItemResponseError = (approveAdminStudioCatalogGenerationItemResponse409) & {
  headers: Headers;
};

export type approveAdminStudioCatalogGenerationItemResponse = (approveAdminStudioCatalogGenerationItemResponseSuccess | approveAdminStudioCatalogGenerationItemResponseError)

export const getApproveAdminStudioCatalogGenerationItemUrl = (itemId: string,) => {




  return `/api/v1/admin/studio-generation/catalog/items/${itemId}/approve`
}

/**
 * @summary Promote the result to first and preserve the source second
 */
export const approveAdminStudioCatalogGenerationItem = async (itemId: string, options?: RequestInit): Promise<approveAdminStudioCatalogGenerationItemResponse> => {

  return orvalClient<approveAdminStudioCatalogGenerationItemResponse>(getApproveAdminStudioCatalogGenerationItemUrl(itemId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApproveAdminStudioCatalogGenerationItemMutationOptions = <TError = StudioCatalogErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminStudioCatalogGenerationItem>>, TError,{itemId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveAdminStudioCatalogGenerationItem>>, TError,{itemId: string}, TContext> => {

const mutationKey = ['approveAdminStudioCatalogGenerationItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAdminStudioCatalogGenerationItem>>, {itemId: string}> = (props) => {
          const {itemId} = props ?? {};

          return  approveAdminStudioCatalogGenerationItem(itemId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAdminStudioCatalogGenerationItemMutationResult = NonNullable<Awaited<ReturnType<typeof approveAdminStudioCatalogGenerationItem>>>

    export type ApproveAdminStudioCatalogGenerationItemMutationError = StudioCatalogErrorResponse

    /**
 * @summary Promote the result to first and preserve the source second
 */
export const useApproveAdminStudioCatalogGenerationItem = <TError = StudioCatalogErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminStudioCatalogGenerationItem>>, TError,{itemId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveAdminStudioCatalogGenerationItem>>,
        TError,
        {itemId: string},
        TContext
      > => {
      return useMutation(getApproveAdminStudioCatalogGenerationItemMutationOptions(options), queryClient);
    }
    export type rejectAdminStudioCatalogGenerationItemResponse200 = {
  data: StudioCatalogBatchRead
  status: 200
}

export type rejectAdminStudioCatalogGenerationItemResponse409 = {
  data: StudioCatalogErrorResponse
  status: 409
}

export type rejectAdminStudioCatalogGenerationItemResponseSuccess = (rejectAdminStudioCatalogGenerationItemResponse200) & {
  headers: Headers;
};
export type rejectAdminStudioCatalogGenerationItemResponseError = (rejectAdminStudioCatalogGenerationItemResponse409) & {
  headers: Headers;
};

export type rejectAdminStudioCatalogGenerationItemResponse = (rejectAdminStudioCatalogGenerationItemResponseSuccess | rejectAdminStudioCatalogGenerationItemResponseError)

export const getRejectAdminStudioCatalogGenerationItemUrl = (itemId: string,) => {




  return `/api/v1/admin/studio-generation/catalog/items/${itemId}/reject`
}

/**
 * @summary Reject the result without changing the catalog gallery
 */
export const rejectAdminStudioCatalogGenerationItem = async (itemId: string,
    studioCatalogRejectRequest: StudioCatalogRejectRequest, options?: RequestInit): Promise<rejectAdminStudioCatalogGenerationItemResponse> => {

  return orvalClient<rejectAdminStudioCatalogGenerationItemResponse>(getRejectAdminStudioCatalogGenerationItemUrl(itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(studioCatalogRejectRequest)
  }
);}




export const getRejectAdminStudioCatalogGenerationItemMutationOptions = <TError = StudioCatalogErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAdminStudioCatalogGenerationItem>>, TError,{itemId: string;data: StudioCatalogRejectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectAdminStudioCatalogGenerationItem>>, TError,{itemId: string;data: StudioCatalogRejectRequest}, TContext> => {

const mutationKey = ['rejectAdminStudioCatalogGenerationItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAdminStudioCatalogGenerationItem>>, {itemId: string;data: StudioCatalogRejectRequest}> = (props) => {
          const {itemId,data} = props ?? {};

          return  rejectAdminStudioCatalogGenerationItem(itemId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectAdminStudioCatalogGenerationItemMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAdminStudioCatalogGenerationItem>>>
    export type RejectAdminStudioCatalogGenerationItemMutationBody = StudioCatalogRejectRequest
    export type RejectAdminStudioCatalogGenerationItemMutationError = StudioCatalogErrorResponse

    /**
 * @summary Reject the result without changing the catalog gallery
 */
export const useRejectAdminStudioCatalogGenerationItem = <TError = StudioCatalogErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAdminStudioCatalogGenerationItem>>, TError,{itemId: string;data: StudioCatalogRejectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectAdminStudioCatalogGenerationItem>>,
        TError,
        {itemId: string;data: StudioCatalogRejectRequest},
        TContext
      > => {
      return useMutation(getRejectAdminStudioCatalogGenerationItemMutationOptions(options), queryClient);
    }
